import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import moment from 'moment';

import { TeamContext } from 'contexts';
import { AppointmentWithThumbnail } from '@bb/domain/dist/types';
import errorReporter from '@app/errorReporter';
import { useDebounce } from 'hooks';
import { LayoutCard, Loading } from '../components';
import TabSection from '../Section/TabSection';

const TeamAppointmentsCard = () => {
  const [appointments, setAppointments] = useState<AppointmentWithThumbnail[]>(
    [],
  );
  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const debouncedSearchValue = useDebounce(searchValue, 500);

  const { targetTeamId } = useContext(TeamContext);

  const fetchAppointments = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get<{
        appointments: AppointmentWithThumbnail[];
        count: number;
      }>('/appointment/my_business/page', {
        params: {
          address: debouncedSearchValue,
          searchType: 'team',
          dateFrom: moment().format('YYYY-MM-DD'),
          sort_field: 'time',
          sort_asc: 'true',
          pageNumber: 0,
          preferences: ['new', 'attempted', 'confirm', 'time_change'],
          targetTeamId,
        },
      });

      setAppointments(data.appointments);
    } catch (err) {
      errorReporter.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAppointments();
  }, [debouncedSearchValue, targetTeamId]);

  return (
    <LayoutCard
      search={{
        searchValue,
        onSearchValueChange: setSearchValue,
      }}
      titleLink={{
        title: <span data-cy="view-all-team-showings">Team Showings</span>,
        linkPath: '/appointment/list/team',
      }}
      defaultActiveTabKey="listing"
      tabList={[{ key: 'listing', tab: 'Listing' }]}
      tabProps={{
        size: 'small',
      }}
      data-cy="dashboard-team-appointments-card"
    >
      {isLoading ? (
        <Loading />
      ) : (
        <TabSection appointments={appointments} team />
      )}
    </LayoutCard>
  );
};

export default TeamAppointmentsCard;
